






































































































































































































































































































import Vue from 'vue';
import Item, { ItemBuilder } from '@/classes/item/item';
import ItemMaster from '@/classes/item/itemMaster';
import Ship from '@/classes/fleet/ship';
import Const from '@/classes/const';
import ShipValidation from '@/classes/fleet/shipValidation';

export default Vue.extend({
  name: 'ItemInput',
  props: {
    handleShowItemList: {
      type: Function,
      required: true,
    },
    value: {
      type: Item,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    readonly: {
      type: Boolean,
    },
    max: {
      type: Number,
      required: true,
    },
    init: {
      type: Number,
      required: true,
    },
    dragSlot: {
      type: Boolean,
      default: true,
    },
    itemParent: {
      type: Ship,
      default: undefined,
    },
    handleDragStart: {
      type: Function,
    },
    isEnemy: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    slotMenu: false,
    slotValue: 0,
    draggingNow: false,
  }),
  computed: {
    item(): Item {
      return this.value;
    },
    isExpandSlot() {
      return this.index === Const.EXPAND_SLOT_INDEX;
    },
    isNoItem() {
      return this.value.data.id === 0;
    },
    isDraggable() {
      return this.value.data.id > 0 && !this.readonly;
    },
    remodelIconColor() {
      if (this.item.data.canRemodel) {
        return 'teal accent-4';
      }
      return 'red lighten-2';
    },
    remodelLabelColor() {
      if (this.item.data.canRemodel) {
        return 'teal--text text--accent-4';
      }
      return 'red--text text--lighten-2';
    },
    itemClass() {
      const classes = ['item-input', `type-${this.value.data.iconTypeId}`];
      if (this.readonly) {
        classes.push('readonly');
      }
      if (this.isExpandSlot) {
        classes.push('expand');
      }
      if (this.isNoItem) {
        classes.push('no-item');
      }
      if (!this.value.data.isPlane) {
        classes.push('not-plane');
      }
      if (!this.isDraggable) {
        classes.push('disabled-draggable');
      }
      return classes.join(' ');
    },
  },
  methods: {
    setItem(value: Item) {
      this.$emit('input', value);
    },
    onSlotMenuToggle() {
      if (!this.slotMenu) {
        // 搭載数メニューCloseイベント
        const builder: ItemBuilder = { item: this.item, slot: Math.floor(this.slotValue) };
        this.setItem(new Item(builder));
      } else {
        // 搭載数メニューOpenイベント
        this.slotValue = this.item.fullSlot;
      }
    },
    removeItem() {
      this.setItem(new Item());
    },
    setLevel(value: number) {
      const builder: ItemBuilder = { item: this.item, level: Const.PROF_LEVEL_BORDER[value] };
      this.setItem(new Item(builder));
    },
    setRemodel(value: number) {
      const builder: ItemBuilder = { item: this.item, remodel: value };
      this.setItem(new Item(builder));
    },
    getLevelValue(value: number) {
      return Const.PROF_LEVEL_BORDER[value];
    },
    showItemList() {
      this.handleShowItemList(this.index);
    },
    dragStart(item: Item, e: DragEvent) {
      const target = e.target as HTMLDivElement;
      // ドラッグ開始条件 item-inputクラスがなかったりしたらドラッグ開始させない
      if (!this.isDraggable || !target || !target.classList || !target.classList.contains('item-input') || !target.draggable) {
        return;
      }
      const transfer = e.dataTransfer as DataTransfer;
      transfer.setData('text/plain', JSON.stringify(item));
      // ドラッグ元を一意識別するためのclassを追加
      target.id = 'dragging-item';
      target.dataset.itemId = `${this.value.data.id}`;
      target.dataset.apiType = `${this.value.data.apiTypeId}`;

      // 一時的に全てのitem inputの子要素マウスイベントを消す
      const itemInputs = document.getElementsByClassName('item-input');
      for (let i = 0; i < itemInputs.length; i += 1) {
        itemInputs[i].classList.add('dragging');
      }

      this.draggingNow = true;
      this.handleDragStart();
    },
    dragEnter(e: DragEvent): void {
      const draggingDiv = document.getElementById('dragging-item');
      const target = e.target as HTMLDivElement;
      if (!draggingDiv || !target || !target.classList || !target.classList.contains('item-input')) {
        return;
      }
      if (target.classList.contains('disabled-drop')) {
        // 判定済み -搭載不可
        target.style.backgroundColor = 'rgba(255, 128, 128, 0.6)';
        return;
      }
      if (target.classList.contains('enabled-drop')) {
        // 判定済み -搭載可
        target.style.backgroundColor = 'rgba(80, 160, 255, 0.6)';
        return;
      }
      // 装備搭載可能チェック
      if (!draggingDiv || !draggingDiv.dataset.itemId || !draggingDiv.dataset.apiType) {
        return;
      }
      const item = new ItemMaster();
      item.id = +draggingDiv.dataset.itemId;
      item.apiTypeId = +draggingDiv.dataset.apiType;
      if (this.itemParent instanceof Ship && !ShipValidation.isValidItem(this.itemParent.data, item, this.index)) {
        // 搭載不可なので背景色を変な色にする
        target.style.backgroundColor = 'rgba(255, 128, 128, 0.6)';
        // 毎回判定していたらダルいので2回目以降判定しないフラグ持たせておく
        target.classList.add('disabled-drop');
      } else {
        // 受け入れ可能 背景色を青っぽく
        target.style.backgroundColor = 'rgba(80, 160, 255, 0.6)';
        // 毎回判定していたらダルいので2回目以降判定しないフラグ持たせておく
        target.classList.add('enabled-drop');
      }
    },
    dragLeave(e: DragEvent) {
      (e.target as HTMLDivElement).style.backgroundColor = '';
    },
    dropItem(e: DragEvent) {
      const draggingDiv = document.getElementById('dragging-item');
      // そもそもドラッグ開始が正常になされているか？
      if (!draggingDiv || !draggingDiv.classList.contains('item-input')) {
        return;
      }
      const target = e.target as HTMLDivElement;
      target.style.backgroundColor = '';

      if (!target.classList.contains('enabled-drop')) {
        // ここにはドロップ不可なのでやめやめ！
        return;
      }
      // 受け渡されたデータ
      const droppedData = (e.dataTransfer as DataTransfer).getData('text/plain');
      // 元々あったitem情報があれば、ドロップ元のdataに一時保管
      if (!this.isNoItem && !e.ctrlKey && draggingDiv) {
        const prevData = JSON.stringify(this.item);
        draggingDiv.dataset.item = prevData;
      }
      if (!e.ctrlKey && draggingDiv) {
        // ドロップ成功したならドラッグ元を消すつもりでIKEYA！
        draggingDiv.classList.add('delete-flg');
      }

      // ドロップされたデータで上書きする
      if (droppedData) {
        const builder: ItemBuilder = { item: JSON.parse(droppedData) as Item };
        if (!this.dragSlot) {
          // 搭載数変更しないオプションがついている => 専ら艦娘画面でのドラッグ操作
          if (builder.item && builder.item.data.apiTypeId === 41) {
            // 大型飛行艇で上書きする => 搭載数を1に減少させる
            builder.slot = 1;
          } else if (this.value.data.apiTypeId === 41) {
            // もともと大型飛行艇が入っていた => 搭載数を引き継がず、初期搭載にする
            builder.slot = this.init;
          } else {
            // 元々入っていた装備の搭載数を引き継ぐ
            builder.slot = this.value.fullSlot;
          }
        }
        this.setItem(new Item(builder));
      }
    },
    dragEnd() {
      // まずはいままで消していたマウスイベントを復帰させる
      const itemInputs = document.getElementsByClassName('item-input');
      for (let i = 0; i < itemInputs.length; i += 1) {
        itemInputs[i].classList.remove('dragging');
      }

      // 判定されていた全てのitem-input情報から判定を解除
      const elements1 = document.getElementsByClassName('enabled-drop');
      while (elements1.length > 0) {
        elements1[0].classList.remove('enabled-drop');
      }
      const elements2 = document.getElementsByClassName('disabled-drop');
      while (elements2.length > 0) {
        elements2[0].classList.remove('disabled-drop');
      }

      const draggingDiv = document.getElementById('dragging-item') as HTMLDivElement;
      if (!draggingDiv || !draggingDiv.draggable) {
        // そもそもドラッグ不可ならなんもせず終わる
        return;
      }
      // ドラッグ元を一意識別するためのidを削除
      draggingDiv.id = '';
      delete draggingDiv.dataset.itemId;
      delete draggingDiv.dataset.apiType;

      const builder: ItemBuilder = {};
      if (!this.dragSlot) {
        // 搭載数変更しないオプションがついているなら搭載数は据え置く
        builder.slot = this.value.fullSlot;
      }

      // 受け渡された対象の装備データ あれば。
      const itemData = draggingDiv.dataset.item;
      if (itemData) {
        // 交換
        builder.item = JSON.parse(itemData) as Item;
        // 交換前にチェック
        if (this.itemParent instanceof Ship) {
          if (!ShipValidation.isValidItem(this.itemParent.data, builder.item.data, this.index)) {
            // 搭載不可なので外す
            builder.item = undefined;
            this.setItem(new Item(builder));
          } else {
            // 日進 & 大型飛行艇調整
            if (builder.item.data.apiTypeId === 41) {
              // 交換として受け渡されてきた装備が大型飛行艇 => 搭載数を1に矯正
              builder.slot = 1;
            } else if (this.value.data.apiTypeId === 41) {
              // 元々ここにあった装備が大型飛行艇 => 搭載数をいったん初期値に矯正
              builder.slot = this.init;
            }
            this.setItem(new Item(builder));
            delete draggingDiv.dataset.item;
          }
        } else {
          this.setItem(new Item(builder));
          delete draggingDiv.dataset.item;
        }
      } else if (draggingDiv.classList.contains('delete-flg')) {
        // 外す処理
        draggingDiv.classList.remove('delete-flg');
        this.setItem(new Item(builder));
      } else {
        // 計算を発火
        this.setItem(new Item({ item: this.value }));
      }

      // drag処理の終了
      this.draggingNow = false;
    },
  },
});
